import type { QueryClient } from "@tanstack/react-query";
import type { PaginatedResultOfGetClassResponse } from "@/openapi/generated/models";
import { createOpenApiConfiguration } from "@/lib/utils";
import { ClassesApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";

export function seedPublicClassesQuery(
  queryClient: QueryClient,
  data: PaginatedResultOfGetClassResponse,
) {
  queryClient.setQueryData([QueryKeys.Classes], data);
}

export async function prefetchClasses(queryClient: QueryClient) {
  const service = new ClassesApi(createOpenApiConfiguration());

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Classes],
    queryFn: () => service.apiClassesScrollGet({ page: 1, pageSize: 1000 }),
  });

  return queryClient;
}
